
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form';
import moment from 'moment';

@Component({
  components: {
  },
})
export default class extends Vue {
  @Prop({ required: true }) private basicPriceList!: any;

  private form = {
    basicUpdateDate: '',
  }

  private rules = {
    basicUpdateDate: [
      { required: true, message: '업데이트 예정일을 입력하세요.', trigger: ['blur', 'change'] },
    ],
  }

  private pickerOptions = {
    disabledDate: (time: any) => {
      const lastBasicPrice = this.basicPriceList[this.basicPriceList.length - 1];
      if (lastBasicPrice.startDate) {
        const lastBasicStartDate = moment(lastBasicPrice, 'YYYY-MM-DD');
        if (moment().isAfter(lastBasicStartDate, 'day')) {
          return moment(time).add(-1, 'days').format('YYYY-MM-DD') < lastBasicPrice.basicUpdateDate;
        }
      }
      return time.getTime() < Date.now();
    },
  }

  private handleSaveBasicPriceUpdate() {
    (this.$refs.form as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.$emit('success', this.form);
      }
    });
  }
}
